import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AssessmentForm } from "@store/assessmentFormSlice";
import { AssessmentHistory } from "@store/generalTypes";

export interface assessmentContext {
    assessmentForms: AssessmentForm[];
    examineeAssessmentHistory: ExamineeAssessmentHistory;
}

export interface ExamineeAssessmentHistory {
    [key: string]: AssessmentHistory[];
}

export interface ExamineeAssessmentHistoryPayload {
    examineeId: number;
    assessmentHistory: AssessmentHistory[];
}

const emptyStartAssessment: assessmentContext = {
    assessmentForms: [],
    examineeAssessmentHistory: {}
};

export const initialState = emptyStartAssessment;

const assessmentContextSlice = createSlice({
    name: "assessmentContext",
    initialState,
    reducers: {
        setAssessmentForms(state, action: PayloadAction<AssessmentForm[]>) {
            state.assessmentForms = action.payload;
        },
        setAssessmentHistoryByExaminee(state, action: PayloadAction<ExamineeAssessmentHistoryPayload>) {
            state.examineeAssessmentHistory[action.payload.examineeId] = action.payload.assessmentHistory;
        }
    }
});

export const { setAssessmentForms, setAssessmentHistoryByExaminee } = assessmentContextSlice.actions;

export default assessmentContextSlice.reducer;
